// Presentation only. Existing route/server guards remain responsible for access.
// Preserve effective legacy parent + child menu visibility for moved links.
const controlPlaneMenuConfig = [
  { label: 'Apps', path: '/apps' },
  { label: 'Projects', path: '/datasets', roles: ['Admin', 'org:admin', 'superadmin'] },
  { label: 'Devices', children: [
    { label: 'Print Managers', path: '/devices', roles: ['superadmin'] },
    { label: 'Printers', path: '/printers', roles: ['org:user', 'org:admin', 'superadmin'] },
    { label: 'Printer Groups', path: '/printergroups', roles: ['org:user', 'org:admin', 'superadmin'] },
  ] },
  { label: 'Design', children: [
    { label: 'Landing Pages', path: '/lpages', roles: ['org:admin', 'superadmin'] },
    { label: 'Card Designs', path: '/cards', roles: ['org:admin', 'superadmin'] },
    { label: 'Media Library', path: '/mediapage', roles: ['org:admin', 'superadmin'] },
    { label: 'Data Templates', path: '/templates/fieldtemplateList', roles: ['org:admin', 'superadmin'] },
  ] },
  { label: 'Reports', path: '/reports' },
  { label: 'Administration', children: [
    { label: 'Organizations', path: '/orgs', roles: ['org:admin', 'superadmin'] },
    // Visibility hint for the registered user-management page, not a role guard.
    { label: 'User Management', path: '/user-management', roles: ['org:admin', 'org:owner', 'superadmin'] },
  ] },
];

export default controlPlaneMenuConfig;
